import Head from "next/head"
import React, { useEffect } from "react"
import ReactHtmlParser from "react-html-parser"
import styled, { css } from "styled-components"
import { breakpoint } from "../layout/styles"
import { Container } from "../styles/Container"
import { formatAsterisk } from '../helpers/string'

const SectionWithHtmlCode = ({ embedCode }: any) => {

  useEffect(() => {
    if (embedCode.style === 'Full') {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = '/scripts/iframeResizer.min.js';
      s.onload = function () {
        const iframes = (window as any).iFrameResize({ log: true });
      }
      document.getElementsByTagName('head')[0].appendChild(s);
    }
  }, [embedCode.style])

  return (
    <Container full={embedCode.style === 'Full'} noMarginTop={embedCode?.style?.toLowerCase() === 'no margin top'}>
      <Content st={embedCode.style}>
        {embedCode.title && <h2>{formatAsterisk(embedCode.title)}</h2>}
        {embedCode.content && ReactHtmlParser(embedCode.content)}
      </Content>
    </Container>
  );
}

export default SectionWithHtmlCode

export const Content = styled.div<any>`
  padding: 0 24px;
  @media ${breakpoint.desktop} {
    padding: 0;
  } 
  &, a {
    color: var(--text);
  };
  ${props => props.st === 'Narrow' && css`
    max-width: 730px;
    margin: 0 auto;
  `}
  ${props => props.st === 'Medium' && css`
    max-width: 920px;
    margin: 0 auto;
  `}
  ${props => props.st === 'Full' && css`
    width: 100%;
    margin-top: -36px;
    iframe {
      width: 100%;
      border: 0;
    }
  `}
  img {
    max-width: 100%;
  }

  h2[style*='-60px'] {
    margin: 0 auto !important;
    @media ${breakpoint.desktop} {
      margin: -60px auto 0 !important;
    }
  }
`
